import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IEventTypeEditItem extends IEditItem {
    parentId: string;
    code: string;
    comment: string;
    eventTypeUsageType: number;
    activeState: number;
    modifyUser: IModifyUser;
}

export class EventTypeEditItem extends EditItem implements IEventTypeEditItem {
    parentId: string;
    code: string;
    comment: string;
    eventTypeUsageType: number;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IEventTypeEditItem);
    constructor(obj?: any) {
        super(obj);
        this.parentId = obj && obj.parentId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.eventTypeUsageType = obj && obj.eventTypeUsageType || 0;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}